module.exports = __webpack_public_path__ + "static/media/col3row1.62d10abf.jpg";